import styled from 'styled-components'

export const VideoWrapper = styled.div`
    position: relative;
    width: 100%;
    background: black;
    /* padding-top: calc(9 / 16 * 100%); */
    aspect-ratio: 3/2;
`

export const CompanyVideo = styled.iframe`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border: none;
`

export const ImageWrapper = styled.div`
    width: 184px;
    height: 80px;
    position: relative;
    display: inline-block;
`
